"use strict";
// NOTE: This code was generated and should not be changed
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMarketingResourceViewNonAuth = void 0;
/**
 * A builder for MarketingResourceViewNonAuth
 *
 * @param data - The event data
 * @return The formatted event data for MarketingResourceViewNonAuthEvent
 */
function createMarketingResourceViewNonAuth(data) {
    return {
        name: 'MarketingResourceViewNonAuth',
        environments: ['browsernonauth'],
        data: data,
    };
}
exports.createMarketingResourceViewNonAuth = createMarketingResourceViewNonAuth;
//# sourceMappingURL=createMarketingResourceViewNonAuth.js.map